export const en = {
    age_0_17: 'from 0 to 17 years',
    age_18_24: 'from 18 to 24 years',
    age_25_34: 'from 25 to 35 years',
    age_35_44: 'from 35 to 44 years',
    age_45_54: 'from 45 to 54 years',
    age_45_inf: 'over 45',
    age_55_inf: 'over 55',
    any: 'any',
    'gender-and-age': 'gender: {gender}, age: {age}',
    gender_any: 'any',
    gender_female: 'female',
    gender_male: 'male',
    'on-condition': 'for "{condition}" criteria'
};
